import React, { FC, useState, useEffect } from 'react';

interface TechMessagesProps {
  messages: string[];
}

export const TechMessages: FC<TechMessagesProps> = ({ messages }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length);
    }, 8000);

    return () => clearInterval(intervalId);
  }, [messages.length]);

  return (
    <div key={index} className="tech-message">
      {messages[index]}
    </div>
  );
};
